export default {
  show: false,
  component: '',
  title: '',
  btnSave: 'Crear',
  btnClose: 'Cerrar',
  closed: () => {},
  saved: () => {},
};
